import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/NewPred.css';
import './css/Summary.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import labService from './labService';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import token_red from './images/token-red.png'
import token_green from './images/token_nqtb.png'
import HashLoader from "react-spinners/HashLoader";


const Summary = ({ isCollapsed, toggleSidebar }) => {
    const navigate = useNavigate();
    const { pk } = useParams();
    const [modelsList, setModelsList] = useState([]);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedModelId, setSelectedModelId] = useState(null);
    const [imageData, setImageData] = useState(null);
    const [analysis, setAnalysis] = useState(null);
    const [loadPage, setloadPage] = useState(true);

    useEffect(() => {

        const user = JSON.parse(localStorage.getItem('user'));

        if (!user) {
            setError("You must be logged in to view this page.");
            return;
        }
        const fetchAnalysis = async () => {
            try {
                const response = await labService.getAnalysisDetail(pk);
                const data = response.data;


                if (data.anal_status === "Done") {
                    navigate('/laboratory'); // Redirect if status is "Done"
                } else {
                    setAnalysis(data); // Set analysis data if status is not "Done"
                    const response2 = await labService.getModelsArray(data.selected_models);
                    setModelsList(response2.data);
                    console.log(response2.data);

                }
            } catch (error) {
                console.error("Error fetching analysis:", error);
                // Handle the error (e.g., show a message, redirect, etc.)
            }
        };

        const fetchImageSmiles = async () => {
            try {
                const response = await labService.getSmilesImage(pk);
                setImageData(response.data.image_data);
            } catch (error) {
                console.error('Error fetching prediction details:', error);
                setError('Failed to fetch models. Please try again.');
            } finally {
                setloadPage(false);
            }
        };

        const fetchSelectedModels = async () => {
            try {
                console.log(analysis.selected_models)
                const response = await labService.getModelsArray(analysis.selected_models);
                setModelsList(response.data.ml_models);
                console.log(response.data.ml_models);

            } catch (error) {
                console.error('Error fetching prediction details:', error);
                setError('Failed to fetch models. Please try again.');
            }
        };

        fetchAnalysis();
        fetchImageSmiles();
        // fetchSelectedModels();
    }, [pk]);


    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo();
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
            
        };

        fetchUserData();
    }, []);


    const closeSelectModels = () => {
        navigate('/laboratory');
    };

    const goBackEdit = () => {
        const { endpoint_type, id } = analysis; // Destructure the needed values
        navigate(`/choose-model/${endpoint_type}/${id}`);
    };

    const handleRunPredictions = async () => {
        // Retrieve user data from localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
            setError("You must be logged in to run predictions.");
            return;
        }
    
        // Prepare the data payload
        const data = { ml_models: analysis.selected_models };

        try {
            // Make the POST request to run predictions
            const response = await labService.runCalcPrediction(pk, data);
            
            // Check if the response contains a redirect URL
            if (response.status === 201 && response.data.redirect_url) {
                navigate(response.data.redirect_url);
            }
        } catch (error) {
            console.error('Error running predictions:', error);
            // Optionally, you can set an error message to display to the user
            setError('Failed to run predictions. Please try again.');
        }
    }; 
    

    const totalCost = modelsList.reduce((sum, model) => {
        return sum + (model.model_price || 0); // Add model_price if it exists, else add 0
    }, 0);


    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={closeSelectModels} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps sum-tab-1'>
                            <p className='p-step'>STEP 1</p>
                            <p>Select Model</p>
                        </div>
                        <div className='np-steps sum-tab-2'>
                            <p className='p-step'>STEP 2</p>
                            <p>Define Compound</p>
                        </div>
                        <div className='np-steps sum-tab-3'>
                            <p className='p-step'>STEP 3</p>
                            <p>Summary</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 4</p>
                            <p>Results</p>
                        </div>
                    </div>

                    <div className='sm-content'>
                        {loadPage ? (
                        <div className='loader-div'>
                            <HashLoader className='loader' size={120} color='#0b5578' />
                        </div>
                        ) : ( <>
                        <div className='np-conte vertical-layout'>

                            {/* Row 1: Analysis name and Div side-by-side */}
                            <div className='anal-name-row'>
                                <p className='main-text anal-name-label'>Analysis name</p>
                                <div className='anal-div-value'>
                                    {analysis ? <p>{analysis.name}</p> : <p>Loading...</p>}
                                </div>
                            </div>

                            {/* Row 2: Substance and Centered Image */}
                            <div className='substance-row'>
                                <p className='main-text'>Substance</p>
                                <div className='image-center-wrapper'>
                                    {imageData ? (
                                        <img className='smiles-img' src={`${imageData}`} alt="Analysis" />
                                    ) : (
                                        <img src="https://via.placeholder.com/300" alt="Compound structure" />
                                    )}
                                </div>
                            </div> 

                            {/* Row 3: Selected Models List */}
                            <div className='models-row'>
                                <p className='main-text'>Selected models</p>
                                <div className='models-list-wrapper'>
                                    {modelsList.map((model) => (
                                        <div key={model.id} className="model-row-sum">
                                            <p className='mdl-name-sum'>{model.model_name}</p>
                                        </div>
                                    ))}  
                                </div>
                            </div>

                            {/* Row 4: Total tokens calculated at left */}
                            <div className='tokens-row'>
                                {user && user.coins < totalCost && (
                                    <div className="token-warning">
                                        <p className="not-enough-tokens">You do not have enough tokens to make this amount of predictions.</p>
                                        <p className='grey-text'>Go to the <span className='boldy'>Wallet tab</span> to top up your account with tokens.</p>
                                    </div>
                                )}
                                <div className='cost-div-sum-left'>
                                    <img
                                        className="token-cost-sum"
                                        src={user && user.coins < totalCost ? token_red : token_green}
                                        alt="token icon"
                                    />
                                    <p className={`${user && user.coins < totalCost ? 'not-enough-tokens-sum' : 'cost-sum'}`}>
                                        Total cost: {totalCost}
                                    </p>
                                </div>
                            </div>

                            {/* Row 5: Bottom Left Back Button, Centered Start Button */}
                            <div className='btns-sum-bottom'>
                                <button className="go-back-btn-sum" onClick={goBackEdit}>Back</button>
                                <button 
                                    onClick={handleRunPredictions} 
                                    className={`start-btn-center ${user && user.coins >= totalCost && totalCost > 0 ? 'run-but-ready-sum' : 'run-but-sum'}`}
                                >
                                    Start prediction
                                </button>
                            </div>

                        </div>

                        
                        </>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Summary;